var map = {
	"./thewest-digital-hero-cropped.jpg": 561,
	"./thewest-digital-hero-variation-a-cropped.jpg": 421,
	"./thewest-digital-hero-variation-a.jpg": 562,
	"./thewest-digital-hero-variation-b-cropped.jpg": 563,
	"./thewest-digital-hero-variation-b.jpg": 998,
	"./thewest-digital-hero.jpg": 999
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;